import Phaser from "phaser";
import ArcherCharacter from "../Character";
import Monster from "../Monster";
import FloatingTexts from "../GUI/FloatText";
import Arrow from "../Arrow";
import ExperiencePoints from "../Character/ExperiencePoints";
import PauseButton from "../GUI/PauseButton";
import SkillManager from "../Skills/SkillManager";
import SkillStorage from "../Storage/SkillStorage";
import CharacterStorage from "../Storage/CharacterStorage";
import StoryStorage from "../Storage/StoryStorage";

export default class PracticeScene extends Phaser.Scene {
  private character: ArcherCharacter;
  private target: Monster;
  private mBackground: Phaser.GameObjects.Image;
  private mFloatingTextx: FloatingTexts;
  private scoreText;
  private score;
  private mPauseButton: PauseButton;

  constructor() {
    super("Practice");
    const skillStorage = new SkillStorage();
    const charStorage = new CharacterStorage();
    const storyStorage = new StoryStorage();
    const skillManager = new SkillManager(skillStorage);
    this.character = new ArcherCharacter(
      this,
      skillManager,
      charStorage,
      storyStorage,
      this.OnHitTarget,
      this.OnPlayerDamage,
      this.OnPlayerLose,
    );
    this.score = 0;
    this.mFloatingTextx = new FloatingTexts(this);
  }

  preload() {
    this.scoreText = this.add.text(10, 10, "Score: 0", {
      font: "15px Arial",
      color: "#FFFFFF",
    });
    this.load.image("practiceBackground", "images/Scenes/Practice.png");
    this.load.image("target", "images/Monsters/target.png");
    this.character.PreLoad();
    this.load.image("resumeButton", "images/resumeButton.png");
    this.load.image("exitButton", "images/exitButton.png");
    PauseButton.preload(this);
  }

  create() {
    let character = this.character;

    let width = this.cameras.main.width;
    let height = this.cameras.main.height;
    this.mBackground = this.add.image(
      width / 2,
      height / 2,
      "practiceBackground",
    );
    this.mBackground.setDisplaySize(width, height);
    this.mBackground.setDepth(-1);

    const exp = ExperiencePoints.create();
    this.character.Create(exp);

    //   this.cursors = this.input.keyboard.createCursorKeys();
    this.input.on("pointerdown", function (pointer) {
      character.PullArrow();
    });
    this.input.on("pointerup", function (pointer) {
      character.ReleaseArrow();
    });

    let sprite = this.physics.add.staticSprite(1000, 400, "target");
    sprite.setScale(0.5, 0.5);

    this.target = new Monster(
      sprite,
      this,
      { Name: "Target", Velocity: 0, MaxHP: 1, ExperienceDrop: 0, Damage: 0 },
      false,
    );
    this.target.ShowHealthBar = false;

    this.mPauseButton = new PauseButton(this);
  }

  update() {
    this.character.Update([this.target]);

    let thisScene = this;
    if (
      thisScene === null ||
      thisScene.input === null ||
      thisScene.input.keyboard === null
    ) {
      return;
    }

    var keyObj = thisScene.input.keyboard.addKey("Esc"); // Get key object
    var isDown = keyObj.isDown;
    if (isDown) {
      this.scene.start("MainMenu");
    }
    //TODO: On escape go back to main menu
  }

  private OnHitTarget(_arrow: Arrow, target: Monster, scene: Phaser.Scene) {
    const practiceScene = scene as PracticeScene;
    practiceScene.mFloatingTextx.AddText(
      _arrow.Damage.toString(),
      target.Sprite().body.x,
      target.Sprite().body.y,
    );

    let addedScore = Math.round(10 * (10 - target.Sprite().scaleX * 10));
    practiceScene.score += addedScore;
    practiceScene.scoreText.text = `Score: ${practiceScene.score}`;

    practiceScene.mFloatingTextx.AddText(
      addedScore.toString(),
      practiceScene.character.GetSprite().body.x,
      practiceScene.character.GetSprite().body.y,
      "#E2A600",
    );

    let newX = practiceScene.getRandomInt(500, 1100);
    let newY = practiceScene.getRandomInt(100, 400);
    target.SetPosition(new Phaser.Math.Vector2(newX, newY));
    let randScale = practiceScene.getRandomInt(5, 85) / 100.0;

    let sprite = target.Sprite();
    sprite.setScale(randScale / 2);
    sprite.body.updateCenter();
    sprite.body.updateFromGameObject();
    sprite.setScale(randScale);
  }

  getRandomInt(min: number, max: number) {
    min = Math.ceil(min);
    max = Math.floor(max);
    return Math.floor(Math.random() * (max - min) + min); //The maximum is exclusive and the minimum is inclusive
  }

  private OnPlayerDamage(scene: Phaser.Scene, monster: Monster) {}

  private OnPlayerLose(scene: Phaser.Scene) {}
}
